<template>
  <div class="cost-summary">
    <div class="cost-item">
      <span class="cost-label">{{ $t('ia.contents.estimatedCredits') }}</span>
      <b-spinner v-if="loading" small class="cost-spinner"></b-spinner>
      <strong v-else :class="{ 'text-danger': insufficient }">
        {{ credits_estimated !== null ? separatebycomma(credits_estimated) : '—' }}
      </strong>
    </div>
    <div class="cost-item">
      <span class="cost-label">{{ $t('ia.contents.availableCredits') }}</span>
      <strong>{{ unlimited ? $t('ia.contents.unlimited') : (credits_available !== null ? separatebycomma(credits_available) : '—') }}</strong>
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";
import { separatebycomma } from '@/libs/utils/formats';

export default {
  name: 'CostSummary',
  components: {
    BSpinner,
  },
  props: {
    credits_estimated: {
      type: Number,
      default: null,
    },
    credits_available: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      separatebycomma,
    };
  },
  computed: {
    unlimited() {
      return this.credits_available === -1;
    },
    insufficient() {
      return !this.unlimited && this.credits_estimated !== null && this.credits_available !== null &&
        this.credits_estimated > this.credits_available;
    },
  },
};
</script>

<style lang="scss" scoped>
.cost-summary {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;

  .cost-item {
    display: flex;
    flex-direction: column;
  }
  .cost-label {
    font-size: 0.8rem;
    color: #6e6b7b;
  }
  .cost-spinner {
    margin-top: 0.25rem;
  }
}
</style>
